import {
  Accessibility,
  Brain,
  Eye,
  Lock,
  Scale,
  Scissors,
  Search,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import type { Principle } from '@marketing/data/principles';

const MAP: Record<Principle['iconKey'], LucideIcon> = {
  eye: Eye,
  brain: Brain,
  lock: Lock,
  scissors: Scissors,
  search: Search,
  scale: Scale,
  a11y: Accessibility,
};

export function PrincipleIcon({
  iconKey,
  size = 28,
}: {
  iconKey: Principle['iconKey'];
  size?: number;
}) {
  const Icon = MAP[iconKey];
  return (
    <span
      aria-hidden="true"
      className="lume-principle-icon"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size + 18,
        height: size + 18,
        borderRadius: 14,
        background:
          'linear-gradient(135deg, var(--color-warm-50) 0%, var(--color-brand-50) 100%)',
        color: 'var(--color-brand-800)',
        boxShadow: 'inset 0 0 0 1px var(--color-border-default)',
      }}
    >
      <Icon size={size} strokeWidth={1.75} aria-hidden="true" />
    </span>
  );
}
